export const setOrderGroup = (orderGroup) => {
    return {
        type: 'SELECT_GROUP',
        orderGroup,
    };
};

export const setOrderGroups = (orderGroups) => {
    return {
        type: 'GROUPS_LIST',
        orderGroups
    };
};

export const reset = () => {
    return {
        type: 'RESET',
    };
};
